import React from "react";
import { Link } from "react-router-dom";
import RainCanvas from "./helpers/RainCanvas";

export default function SplashScreen() {
  return (
    <>
     <section className="splash_layers splash_body">
		<div className="splash_layers__container">
			<div className="splash_layers__item splash_layer-1" style={{backgroundImage: "url(assets/SplashScreen/img/layer-1.jpg)"}}></div>
			<div className="splash_layers__item splash_layer-2" style={{backgroundImage: "url(assets/SplashScreen/img/layer-2.png)"}}></div>
			<div className="splash_layers__item splash_layer-3">
				<div className="splash_hero-content" style={{color: 'white'}}>
					<h1 className="splash_title" style={{color: 'white', fontWeight: 'bold'}}>BioUniverse<span style={{fontSize: "3rem", color: 'white'}}>Expand your world a little more</span></h1>
					<div className="splash_hero-content__p">Created By Vishal</div>
					<Link className="splash_button-start mr-4" to='/home'>Start Learning</Link>
					<Link className="splash_button-start pl-lg-5 pr-lg-5 pl-sm-4 pr-sm-4 ml-4" to='/admin_login'>Admin Login</Link>
				</div>
			</div>
			<div className="splash_layers__item splash_layer-4">
				<canvas className="splash_rain"></canvas>
			</div>
			<div className="splash_layers__item splash_layer-5" style={{backgroundImage: "url(assets/SplashScreen/img/layer-5.png)"}}></div>
			<div className="splash_layers__item splash_layer-6" style={{backgroundImage: "url(assets/SplashScreen/img/layer-6.png)"}}></div>
            <RainCanvas/>
        </div>
	</section>
    </>
  );
}
